export { default } from './ReferralTotalInfoBlock';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/ReferralTotalInfoBlock/index.js